export const READY = "ready";
export const RUNNING = "running";
export const COMPLETED = "completed";
export const FAILED = "failed";
